import { render, staticRenderFns } from "./ClaimAccountTerms.vue?vue&type=template&id=e271d544&scoped=true"
import script from "./ClaimAccountTerms.vue?vue&type=script&lang=ts"
export * from "./ClaimAccountTerms.vue?vue&type=script&lang=ts"
import style0 from "./ClaimAccountTerms.vue?vue&type=style&index=0&id=e271d544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e271d544",
  null
  
)

export default component.exports